<div class="team-page-container mt-4 mb-4">
  
  <!-- BACK BUTTON -->
  <div class="mb-4">
    <a mat-button routerLink="/statistics" [state]="{ restoreSearch: true }">
      <mat-icon>arrow_back</mat-icon>
      Volver a Equipos
    </a>
  </div>

  <!-- LOADING SPINNER -->
  <div *ngIf="isLoading && !teamInfo" class="d-flex justify-content-center my-5">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <ng-container *ngIf="teamInfo">
    <!-- HEADER REUTILIZADO -->
    <app-team-detail-header [teamInfo]="teamInfo"></app-team-detail-header>

    <!-- ACCIONES Y SELECTOR DE TEMPORADA -->
    <div class="d-flex justify-content-between align-items-center mt-4 mb-3 ps-3 pe-3 bg-white border rounded shadow-sm py-3 header-controls">
      <h2 class="m-0 text-primary fw-bold">Análisis IA de Partidos</h2>
      
      <mat-form-field appearance="outline" class="season-selector m-0">
        <mat-label>Temporada</mat-label>
        <mat-select [value]="currentSeasonId" (selectionChange)="onSeasonChange($event)">
          <mat-option [value]="null">Todas las temporadas</mat-option>
          <mat-option *ngFor="let s of seasons" [value]="s.id">
            {{ s.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- EL SELECTOR DE VÍDEOS PENDIENTE DE IMPLEMENTAR COMPLETAMENTE EN OTRO COMPONENTE -->
    <div class="mt-4">
      <app-stats-ai-video-selector 
        (pageChanged)="onPageChanged($event)"
        (analyzeClicked)="onAnalyzeClicked()">
      </app-stats-ai-video-selector>
    </div>

    <!-- AQUÍ IRÁ EL COMPONENTE DEL DASHBOARD DE IA STATS (Nivel 3) -->
    <div id="stats-ai-dashboard-section" class="mt-5" *ngIf="state.statsOverview()">
      <h3 class="fw-bold mb-3 d-flex align-items-center">
        <mat-icon class="text-success me-2">insights</mat-icon>
        Dashboard de Resultados IA
      </h3>
      
      <!-- Panel de Filtros Adicionales (Ej: Por rival) -->
      <app-stats-ai-filter-panel></app-stats-ai-filter-panel>

      <ng-container *ngIf="showOpponentDashboard; else defaultDashboard">
        <app-stats-ai-dashboard-comparison
          [teamStats]="state.statsOverview()!"
          [opponentStats]="opponentStats!"
          [teamLabel]="teamName"
          [opponentLabel]="opponentTeamName"
        ></app-stats-ai-dashboard-comparison>
      </ng-container>

      <ng-template #defaultDashboard>
        <app-stats-ai-dashboard
          [stats]="state.statsOverview()!"
          [singleMatchMode]="state.effectiveVideoIds().length === 1"
        ></app-stats-ai-dashboard>
      </ng-template>
    </div>
  </ng-container>

</div>
